<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal()")

    div.modal-main

        header.modal-header
            sectionHeader(:title="formExportTitle")

        div.modal-body

            div.form-section
                div.form-subsection(v-if="formExport.type === 'segment'")
                    div.form-label
                        label Type of data

                    el-select.form-export-data(
                        v-model="exportForm"
                        placeholder="Select an object"
                        value-key="id"
                    )
                        el-option.form-export-data-option(
                            v-for="type in segmentExportTypesList"
                            :label="type.label"
                            :key="type.id"
                            :value="type"
                            :title="type.label"
                        )
                            span(style="float: left") {{ type.label }}


                div.form-subsection
                    div.form-label__required
                        label Email
                    input.form-input(
                        id="email"
                        name="email"
                        placeholder="user@weborama.com"
                        v-model="exportFormEmail"
                        v-validate="'max:255|required|email'"
                        type="text"
                    )
                    span.form-validate-error {{ errors.first('email') }}

                div.form-subsection
                    div.form-label.l-flex-row--between
                        label Emails Cc
                        div.counter {{ exportFormCcList.length }}/10
                    EmailCcField(
                        parent="FormExportData"
                        placeholder="cc@weborama.com"
                        :maxItems="10"
                        @formCcListUpdate="updateFormCcList"
                    )

                div.form-subsection.form-section-recency.l-flex-column(v-if="displayRecency")
                    div.form-section-title Recency
                    el-slider(
                        v-model.number="recency"
                        :disabled="is395daysRetention"
                        :min="sliderRange.min"
                        :max="sliderRange.max"
                        :marks="sliderMarks"
                        show-input
                    )

        //- FOOTER
        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
                button.btn.btn--medium.btn--round.btn-rev(
                    :class="{'ui-disabled': disableCta}"
                    @click="exportData()") Export

</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

//components
import SectionHeader from '@/components/common/SectionHeader'
import EmailCcField from '@/components/common/EmailCcField'
import { RANGES, EXPORT_TYPES_BUILDER } from '@/utils/constants'
import { getTokenUserEmail } from '@/utils/helpers'

import Vue from 'vue'
import { join, isEmpty, cloneDeep } from 'lodash'

export default {
    name: 'FormExportData',

    components: {
        SectionHeader,
        EmailCcField
    },

    data() {
        return {
            exportForm: {
                value: '',
                label: '',
                retention: ''
            },
            exportFormCcList: [],
            exportFormEmail: getTokenUserEmail(Vue.prototype.$keycloak),
            inputCcValue: '',
            recency: RANGES.recency.max,
            processing: false
        }
    },

    mounted() {
        // Initializing with the first custom taxonomies available as default value
        if (this.customTaxonomies[0]) {
            this.exportForm = {
                id: this.customTaxonomies[0].id,
                label: this.customTaxonomies[0].label,
                retention: this.customTaxonomies[0].retention,
                value: 'wam_custom_taxonomy'
            }
        }
        this.recency = this.formula?.defaultRecency?.value || 30
    },

    computed: {
        // Callt to state
        ...mapState('account', {
            accountId: state => state.accountId,
            userRole: state => state.userRole
        }),
        ...mapState('builder', {
            formula: state => state.formula
        }),
        ...mapState('data/customTaxonomies', {
            customTaxonomies: state => state.customTaxonomies
        }),
        ...mapState('exports', {
            formExport: state => state.formExport
        }),
        ...mapState('data', {
            dataState: state => state
        }),

        // Call to getters
        ...mapGetters('data/media', ['getIsConversionEmpty', 'getIsCampaignEmpty']),

        formExportTitle() {
            let _exportType = ''
            if (this.formExport.type === 'cclone') _exportType = 'CClones'
            if (this.formExport.type === 'audience_monitoring') _exportType = 'Audiences'
            if (this.formExport.type === 'transfer') _exportType = 'Transfers'
            if (this.formExport.type === 'segment') _exportType = 'Segments'
            return _exportType + ' Export'
        },

        displayRecency() {
            return !['audience_monitoring', 'cclone', 'transfer'].includes(this.formExport.type)
        },

        segmentExportTypesList() {
            const isWeboUser = this.userRole === 'webo_user'
            if (this.formExport.type === 'segment') {
                const customTaxo = []
                const notEmptyTypes = []
                for (const taxo of this.customTaxonomies) {
                    const individualTaxo = {}
                    individualTaxo.retention = taxo.retention
                    individualTaxo.value = 'wam_custom_taxonomy'
                    individualTaxo.label = taxo.label
                    individualTaxo.id = taxo.id
                    customTaxo.push(individualTaxo)
                }
                for (const type of EXPORT_TYPES_BUILDER) {
                    if (type.value === 'audience') {
                        if (!isEmpty(this.dataState[type.value].list)) {
                            customTaxo.push(type)
                        }
                    } else if (type.value === 'media') {
                        if (!this.getIsConversionEmpty() || !this.getIsCampaignEmpty()) {
                            customTaxo.push(type)
                        }
                    }
                    if (!isWeboUser) {
                        if (type.value === 'second_party') {
                            if (!isEmpty(this.dataState['secondParty'].activeList)) {
                                customTaxo.push(type)
                            }
                        } else if (type.value === 'third_party') {
                            if (
                                (!isEmpty(this.dataState['behavioral'].list) && this.dataState.settings.sociodemo.behavioral) ||
                                (!isEmpty(this.dataState['demographic'].list) && this.dataState.settings.sociodemo.demographic)
                            ) {
                                customTaxo.push(type)
                            }
                        } else if (type.value === 'geographic') {
                            if (!isEmpty(this.dataState['geography'].list) && this.dataState.settings.sociodemo.geography) {
                                customTaxo.push(type)
                            }
                        } else if (type.value === 'technologic') {
                            if (
                                this.dataState.settings.sociodemo.technology &&
                                (!isEmpty(this.dataState['isp'].list) ||
                                    !isEmpty(this.dataState['browser'].list) ||
                                    !isEmpty(this.dataState['os'].list) ||
                                    !isEmpty(this.dataState['device'].list))
                            ) {
                                customTaxo.push(type)
                            }
                        }
                    }
                }
                return customTaxo.concat(notEmptyTypes)
            }
            return []
        },

        sliderRange() {
            if (this.displayRecency) {
                const range = cloneDeep(RANGES.recency)
                if (this.is395daysRetention) range.max = 395
                return range
            }
            return {}
        },

        sliderMarks() {
            return {
                [this.sliderRange.min]: this.sliderRange.min.toString(),
                [this.sliderRange.max]: this.is395daysRetention ? '395' : this.sliderRange.max.toString()
            }
        },

        disableCta() {
            return this.processing || this.errors.items.length > 0 || isEmpty(this.exportForm.label) || isEmpty(this.exportForm.value)
        },

        is395daysRetention() {
            return this.exportForm.retention === '395'
        }
    },

    watch: {
        exportForm: {
            handler(val) {
                if (val.retention === '395') this.recency = 395
                else if (val.retention !== '395' && this.recency === 395) this.recency = 30
            },
            deep: true
        }
    },

    methods: {
        // Callt to actions
        ...mapActions('exports', ['requestDataExport']),
        // Callt to mutations
        ...mapMutations('exports', ['setExportForm']),
        closeModal() {
            this.processing = false
            this.setExportForm({
                display: false,
                type: ''
            })
        },
        updateFormCcList(ccList) {
            this.exportFormCcList = ccList
        },

        exportData() {
            if (this.processing) return // Prevent multiple export
            this.processing = true
            this.$validator.validateAll().then(result => {
                if (result) {
                    const exportParams = {
                        account_id: this.accountId,
                        email: this.exportFormEmail,
                        cc: join(this.exportFormCcList, ','),
                        type: this.formExport.type === 'segment' ? this.exportForm.value : this.formExport.type,
                        recency: this.recency
                    }
                    if (this.exportForm.value === 'wam_custom_taxonomy') {
                        exportParams.wam_custom_taxonomy_id = this.exportForm.id
                    }
                    // Send data to API
                    this.requestDataExport(exportParams)
                    this.closeModal()
                } else {
                    // Do stuff if not valid.
                    const message = 'Form invalid'
                    throw Error(message)
                }
            })
        }
    }
}
</script>
